export { EducationPopupModel } from './EducationPopup.model';
export { EducationModel } from './Education.model';
